import React, {Fragment} from 'react';
import {Parallax} from "react-scroll-parallax";

import image from '../../../public/healthInfo/health-info-fourth.png';

let isSafari;

var ua = navigator.userAgent.toLowerCase();

export default function Fourth(props) {

    const {apiData} = props;

    if (ua.indexOf('safari') !== -1) {
        if (ua.indexOf('chrome') > -1) {

        } else {
            isSafari = true;
        }
    }

    return (
        <div className='health-info__fourth health-info__block'>
            {
                isSafari ?
                    <Parallax y={[0, 20]}>
                    <img className='health-info__image-left health-info__image-fourth health-info__image' data-image={image}/>
                </Parallax>
                    : <img className='health-info__image-left health-info__image-fourth health-info__image' data-image={image}/>
            }
            {
                !isSafari
                    ? <Parallax y={[20, -20]}>
                        <div className='health-info__circle' style={{backgroundColor: '#fef9f1'}}>
                            <Parallax y={[20, -20]}>
                                <h6 className='health-info__title health-info__title-fourth' dangerouslySetInnerHTML={{__html: apiData.health_info_fourth_main}}></h6>
                                <p className='health-info__description health-info__description-fourth' dangerouslySetInnerHTML={{__html: apiData.health_info_fourth_under_main}}>
                                </p>
                            </Parallax>
                        </div>
                    </Parallax>
                    : <Fragment>
                        <div className='health-info__circle' style={{backgroundColor: '#fef9f1'}}>
                            <Fragment>
                                <h6 style={{marginTop: 0}} className='health-info__title health-info__title-fourth' dangerouslySetInnerHTML={{__html: apiData.health_info_fourth_main}}></h6>
                                <p className='health-info__description health-info__description-fourth' dangerouslySetInnerHTML={{__html: apiData.health_info_fourth_under_main}}>
                                </p>
                            </Fragment>
                        </div>
                    </Fragment>
            }
        </div>
    )
}